import { voiceEngine } from "./VoiceEngine";
export class ActionRunInfo {
}
export class VoiceCommand {
    constructor(data) {
        this.VSet(data);
    }
}
let lastVoiceKeyNumber = 1600;
function GetAutoVoiceKey() {
    let voiceKeyNumber = lastVoiceKeyNumber + 1;
    // don't accept multiples of 10, else, eg. "..49" might be recognized as "..40" prior to "..49"
    if (voiceKeyNumber.toString().endsWith("0")) {
        voiceKeyNumber++;
    }
    lastVoiceKeyNumber = voiceKeyNumber;
    return voiceKeyNumber.toString();
}
/*
There are two main schemes for voice-keys:
1) "go [command]"
2) "[command first-word] [command first-word] [rest of command]"

Note: Any command can be applied multiple times by adding "times X" or "plus X" to the end.
*/
export const voiceCommands = [
    // insertion point
    // ==========
    // back/forward
    { name: "Go back X letters", voiceKeys: ["go back \\d+ letters"], action: () => { } },
    { name: "Go forward X letters", voiceKeys: ["go next \\d+ letters"], action: () => { } },
    { name: "Go back X words", voiceKeys: ["go back \\d+ words"], action: () => { } },
    { name: "Go forward X words", voiceKeys: ["go next \\d+ words"], action: () => { } },
    { name: "Go back X sentences", voiceKeys: ["go back \\d+ sentences"], action: () => { } },
    { name: "Go forward X sentences", voiceKeys: ["go next \\d+ sentences"], action: () => { } },
    { name: "Go back X paragraphs", voiceKeys: ["go back \\d+ paragraphs"], action: () => { } },
    { name: "Go forward X paragraphs", voiceKeys: ["go next \\d+ paragraphs"], action: () => { } },
    { name: "Go up X lines", voiceKeys: ["go up \\d+ lines"], action: () => { } },
    { name: "Go down X lines", voiceKeys: ["go down \\d+ lines"], action: () => { } },
    // before/after
    { name: "Go before last word X", voiceKeys: ["go before \\w+"], action: () => { } },
    { name: "Go before next word X", voiceKeys: ["go before next \\w+"], action: () => { } },
    { name: "Go after last word X", voiceKeys: ["go after \\w+"], action: () => { } },
    { name: "Go after next word X", voiceKeys: ["go after next \\w+"], action: () => { } },
    // selection
    // =========
    { name: "Select last X letters", voiceKeys: ["go grab \\d+ letters"], action: () => { } },
    { name: "Select next X letters", voiceKeys: ["go grab next \\d+ letters"], action: () => { } },
    { name: "Select last X words", voiceKeys: ["go grab \\d+ words"], action: () => {
            const input = document.activeElement;
            if (input == null || !input.matches("input[type=text], textarea"))
                return;
            const textBeforeSelection = input.value.slice(0, input.selectionStart);
            const wordMatches = textBeforeSelection.Matches(/\w+/);
            if (wordMatches.length) {
                const wordsToSelect = 1;
                const lastWordToStayAfter = wordMatches.slice(0, wordMatches.length - wordsToSelect).LastOrX();
                input.selectionStart = lastWordToStayAfter ? lastWordToStayAfter.index + lastWordToStayAfter[0].length : 0;
            }
        } },
    { name: "Select next X words", voiceKeys: ["go grab next \\d+ words"], action: () => { } },
    { name: "Select last X sentences", voiceKeys: ["go grab \\d+ sentences"], action: () => { } },
    { name: "Select next X sentences", voiceKeys: ["go grab next \\d+ sentences"], action: () => { } },
    { name: "Select last X paragraphs", voiceKeys: ["go grab \\d+ paragraphs"], action: () => { } },
    { name: "Select next X paragraphs", voiceKeys: ["go grab next \\d+ paragraphs"], action: () => { } },
    { name: "Select word X", voiceKeys: ["go grab \\d+"], action: () => { } },
    { name: "Select next word X", voiceKeys: ["go grab next \\d+"], action: () => { } },
    { name: "Start select", voiceKeys: ["go start select"], action: () => { } },
    { name: "End select", voiceKeys: ["go end select"], action: () => { } },
    { name: "Select all", voiceKeys: ["go select all"], action: () => {
            /*if (document.body.createTextRange) {
                var range = document.body.createTextRange();
                range.moveToElementText(element);
                range.select();
            } else if (window.getSelection) {*/
            /*var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(document.activeElement);
            selection.removeAllRanges();
            selection.addRange(range);*/
            if (document.activeElement["select"])
                document.activeElement["select"]();
        } },
    { name: "Deselect", voiceKeys: ["go deselect"], action: () => {
            const selection = window.getSelection();
            if (selection.empty)
                selection.empty();
            if (selection.removeAllRanges)
                selection.removeAllRanges();
        } },
    // edits (on selection)
    // ==========
    { name: "Cut", voiceKeys: ["cut cut"], action: () => {
            //var successful = document.execCommand("cut", false, null);
            FakeCut();
        } },
    { name: "Copy", voiceKeys: ["copy copy"], action: () => {
            //var successful = document.execCommand("copy", false, null);
            FakeCopy();
        } },
    { name: "Paste", voiceKeys: ["paste paste"], action: () => {
            //var successful = document.execCommand("paste", false, null);
            FakePaste();
        } },
    { name: "Delete", voiceKeys: ["delete delete"], action: () => {
            DeleteSelectedText();
        } },
    //{name: "Delete X words", voiceKeys: ["delete delete X words"], action: ()=>{}},
    { name: "Start letter-insert mode", voiceKeys: ["spell spell"], action: () => { } },
    { name: "Stop letter-insert mode", voiceKeys: ["stop stop"], action: () => { } },
    // edits (others)
    // ==========
    /*{name: "Undo (Text)", voiceKeys: ["undo undo"], action: ()=>{
        PreTextChange();
        document.execCommand("undo");
        PostTextChange();
    }},
    {name: "Redo (Text)", voiceKeys: ["redo redo"], action: ()=>{
        PreTextChange();
        document.execCommand("redo");
        PostTextChange();
    }},*/
    { name: "Undo (DB)", voiceKeys: ["go step back"], action: () => { } },
    { name: "Redo (DB)", voiceKeys: ["go step forward"], action: () => { } },
    // special characters
    // ==========
    { name: "enter", voiceKeys: ["enter enter"], action: () => {
            InsertText(`\n`);
        } },
    { name: "tab", voiceKeys: ["(tab|tap) (tab|tap)"], action: () => {
            InsertText(`\t`);
        } },
    { name: "space", voiceKeys: ["space space"], action: () => {
            InsertText(` `);
        } },
    { name: "dot", voiceKeys: ["\\.\\."], ignore: ["dot."], action: () => {
            InsertText(`.`);
        } },
    { name: "comma", voiceKeys: [",,"], ignore: ["cama cama"], action: () => {
            InsertText(`,`);
        } },
    { name: `quote (')`, voiceKeys: ["single single quote"], action: () => {
            InsertText(`'`);
        } },
    { name: `quote (")`, voiceKeys: ["quote quote"], action: () => {
            InsertText(`"`);
        } },
].map((data, index) => {
    const voiceKeys = [];
    voiceKeys.push(GetAutoVoiceKey());
    voiceKeys.push(...(data.voiceKeys ?? []));
    return new VoiceCommand({
        index,
        name: data.name,
        voiceKeys,
        action: data.action,
    });
});
export function InsertText(text) {
    const input = document.activeElement;
    //let selection = getSelection();
    if (input == null || !input.matches("input[type=text], textarea"))
        return;
    //const selectionStart = input.selectionStart;
    //const selectionEnd = input.selectionEnd;
    //const preText = input.value.slice(0, input.selectionStart);
    //const postText = input.value.slice(input.selectionEnd);
    PreTextChange();
    let newText = input.value;
    newText = newText.slice(0, input.selectionStart) + text + newText.slice(input.selectionEnd);
    //newText = preText + text + postText;
    //input.value = newText;
    SetTextValue(input, newText);
    PostTextChange();
}
export let fakeClipboard;
export function FakeCut() {
    FakeCopy();
    DeleteSelectedText();
}
export function FakeCopy() {
    const input = document.activeElement;
    //let selection = getSelection();
    if (input == null || !input.matches("input[type=text], textarea"))
        return;
    const text = input.value;
    const selectedText = text.slice(input.selectionStart, input.selectionEnd);
    fakeClipboard = selectedText;
    Log("Copied:", fakeClipboard);
}
export function FakePaste() {
    if (!fakeClipboard)
        return;
    InsertText(fakeClipboard);
}
export function DeleteSelectedText() {
    // commented; this approach doesn't update element.value (until defocused), despite text visual-deletion
    /*PreTextChange();
    const selection = window.getSelection();
    selection.deleteFromDocument();
    PostTextChange());*/
    InsertText(""); // accomplishes delete, since InsertText("") replaces selected text with empty-str
}
/*const timer1 = new Timer(1000, ()=>{
    Log(`Val:${document.activeElement?.["value"]}`);
}).Start();*/
export function PreTextChange() {
    voiceEngine.CommitVoiceTyping();
}
export function PostTextChange() {
    voiceEngine.UpdateFocusElInfo(true);
}
export function SetTextValue(el, val, preserveSelection = true) {
    const oldSelectionStart = el.selectionStart;
    const oldSelectionEnd = el.selectionEnd;
    el.value = val;
    if (preserveSelection && oldSelectionEnd > oldSelectionStart) {
        el.selectionStart = oldSelectionStart;
        el.selectionEnd = oldSelectionEnd;
    }
}
